export function isMaintenanceResponse(status: number | undefined, data: unknown): boolean {
  if (status !== 503 || !data || typeof data !== 'object') return false;

  const info = data as Record<string, unknown>;
  if (info.errorCode === 'maintenance') return true;

  // Support the existing MaintenanceInfo response until maintenance has an explicit code.
  return (
    (info.errorCode === undefined || info.errorCode === null) &&
    info.status === 503 &&
    typeof info.title === 'string' &&
    typeof info.detail === 'string' &&
    (info.estimatedEndTime === null || typeof info.estimatedEndTime === 'string') &&
    typeof info.retryAfterSeconds === 'number'
  );
}
